import { FakeData } from "constants/FakeData";
import { funcFormatDate } from "functions/funcFormatDate";
import { funcFormatTime } from "functions/funcFormatTime";
import useClickOutSide from "hooks/useClickOutSide";
import React, { useState } from "react";
import { v4 } from "uuid";

const DropdownNotification = () => {
	const dataNoti = FakeData.dataNotification;
	const { show, setShow, nodeRef } = useClickOutSide(".wrap-noti");
	return (
		<div className="wrap-noti" ref={nodeRef}>
			<div
				className='icon-notification relative flex cursor-pointer select-none'
				onClick={() => setShow(prev => !prev)}>
				<em className='fa-regular fa-bell'></em>
				<div className='quantity w-4 h-4 rounded-full flex items-center justify-center text-white bg-primary text-10px absolute top-0 right-0 translate-x-3 -translate-y-1'>
					{dataNoti.length}
				</div>
			</div>
			{show && (
				<div
					key={v4()}
					className={`dropdown-notification absolute top-full right-0 opacity-0 px-5 py-10px pb-4 w-350px bg-white z-10 transition-all invisible mt-2 pr-2 shadow-[0px_4px_10px_rgba(0,0,0,0.15)] ${
						show ? "active" : ""
					}`}>
					<ul className='max-h-350px overflow-auto h-full pr-2'>
						{dataNoti &&
							dataNoti.length &&
							dataNoti.map(item => (
								<li
									className='border-b border-b-[#e4e4e4] py-2'
									key={v4()}>
									<div className='date-notification text-gray-1 text-sm'>
										<span>{funcFormatTime(item.date)}</span>
										<span className='mx-1'>|</span>
										<span>{funcFormatDate(item.date)}</span>
									</div>
									<div className='title-notification text-sm hover:text-blue-2 transition-all'>
										{item.content}
									</div>
								</li>
							))}
					</ul>
				</div>
			)}
		</div>
	);
};

export default DropdownNotification;
